
import appError from '#shared/util/appError.js';
import json from '#shared/util/json.js';
import logger from '#shared/util/logger.js';
import readArguments from '#shared/util/readArguments.js';
import isObject from '#shared/util/isObject.js';

import closeWindow from './closeWindow.js';

/**
 * On window close event
 * @returns {Function}
 */
export default (function() {
	const callbacks = [];
	if (typeof window.top.postMessage === 'function') {
		window.top.postMessage({
			action: 'register.event.windowClosed'
		}, '*');
		window.addEventListener('message', (event) => {
			if (/^.+\.(?:avast|avg)\.com$/.test(event.origin) && isObject(event.data) && event.data.action === 'windowClosed' && typeof window.onWindowClosed === 'function') {
				window.onWindowClosed();
			}
		}, false);
	}

	/**
	 * Add callback
	 * @param {Function} callback
	 */
	return function(callback) {
		if (typeof callback === 'function') {
			if (!callbacks.length) {
				window.onWindowClosed = function() {
					callbacks.forEach((callback) => {
						try {
							callback();
						} catch (error) {
							logger.warn({
								code: 'CLIENT',
								origin: 'onWindowClose',
								detail: json.parse(error) || {}
							});
						}
					});
					closeWindow();
				};
			}
			// Find existing function by name from callbacks array
			const existingCallbackIndex = callbacks.findIndex((existingCallback) => existingCallback.name === callback.name);
			// Push callback into callbacks
			callbacks.push(callback);
			// Remove existing function from callback array
			if (existingCallbackIndex >= 0) {
				callbacks.splice(existingCallbackIndex, 1);
			}
		} else {
			throw appError('Invalid method arguments to onWindowClose', {
				code: 'APP_FRONTEND_UTIL',
				origin: 'onWindowClose',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	};
})();
